import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import { authService } from '../api/auth';
import './Login.css';

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState(() => localStorage.getItem('username') || '');
  const [password, setPassword] = useState(() => localStorage.getItem('password') || '');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(() => localStorage.getItem('rememberMe') === 'true');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const response = await authService.login(username, password);
      localStorage.setItem('token', response.access_token);
      localStorage.setItem('isAuthenticated', 'true');

      // Сохраняем логин, пароль и настройку "запомнить" если выбрано
      if (rememberMe) {
        localStorage.setItem('username', username);
        // Note: Storing password in localStorage is not secure, but keeping existing logic for now if requested
        // Better to just store username
        localStorage.setItem('password', password);
        localStorage.setItem('rememberMe', 'true');
      } else {
        localStorage.removeItem('username');
        localStorage.removeItem('password');
        localStorage.removeItem('rememberMe');
      }

      onLogin();
      navigate('/');
    } catch (err: any) {
      console.error(err);

      // Handle different error types from backend
      if (err.response) {
        const { status, data } = err.response;

        if (status === 401 && data?.detail) {
          // Incorrect credentials with attempts remaining
          setError(data.detail);
        } else if (status === 429 && data?.detail) {
          // Account locked due to brute force protection
          setError(data.detail);
        } else {
          // Other 401 errors or unexpected errors
          setError('Неверный логин или пароль');
        }
      } else {
        // Network errors or other issues
        setError('Ошибка подключения. Проверьте интернет-соединение.');
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="logo-container">
          <img src="/logo_education.png" alt="Иннопрог" className="logo" />
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Логин</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Пароль</label>
            <div className="password-input-container">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-group remember-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span className="checkmark"></span>
              Запомнить меня
            </label>
          </div>

          <button type="submit" className="login-button">
            Войти
          </button>
        </form>
      </div>

    </div>
  );
};

export default Login;